import { Component, OnInit } from '@angular/core';
import { StationService } from '../../service/station/station.service';
import { Station } from '../../class/station';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../interfaces/marker';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';

@Component({
  selector: 'app-stations',
  templateUrl: './stations.component.html',
  styleUrls: ['./stations.component.scss']
})
export class StationsComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public stations: Station[];
    public selectStation: Station;
    public stationID: Number = 0;
    public modNew = false;
    public modView = false;
    public modMap = false;
    public openStation = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;

    public zoom: number;
    public latitude: number;
    public longitude: number;
    public markers: Marker[];

    constructor(
        public stationService: StationService,
        public confirmationService: ConfirmationService,
        public hasPermissionService: HasPermissionService,
        public translate: TranslateService,
        private mapsAPILoader: MapsAPILoader) { }

    ngOnInit() {
        // set google maps defaults
        this.zoom = 5;
        this.latitude = 4.68768189999999;
        this.longitude = -74.05805479999998;

        //this.getStations();
        this.getAllStations();
        this.page = 1;
        this.per_page = 10;
    }

    public loadStationsLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }
        this.getStations(event.globalFilter);
    }

    public getStations(query?: string) {
        this.stationService.getStation(this.page, this.per_page, this.sort, query).toPromise().then(
            response => {
                this.stations = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public getAllStations(query?: string) {
        this.stationService.getStation(this.page, 10000, this.sort, query).toPromise().then(
            response => {
                this.stations = response.json().data;
                this.markers = [];
                this.stations.forEach(element => {
                    console.log(element.name);
                    this.markers.push ({
                        lat: element.latitude,
                        lng: element.longitude,
                        label: element.name,
                        draggable: false
                    });
                });

                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newStation() {
        this.modNew = !this.modNew;
        this.selectStation = null;
    }

    public savedStation(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectStation = null;
        this.modNew = false;
        this.getStations();
    }

    public cancelStation (res) {
        this.selectStation = null;
        this.modNew = false;
        this.modView = false;
        this.modMap = false;
        this.getStations();
    }

    public edit(station: Station) {
        this.modNew = true;
        this.selectStation = station;
        this.getStations();
    }

    public view(station: Station) {
        this.openStation = true;
        this.selectStation = station;
        this.stationID = station.id;
        this.modView = true;
    }

    public mapView() {
        this.modMap = true;
    }

    public deleteDialog(station: Station) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(station);
            }
        });
    }

    public delete(station: Station) {
        this.stationService.deleteStation(station.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getStations();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeStation(station: Station) {
        this.putStation(station);
    }

    public putStation(values: Station) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.stationService.updateStation(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/stations/stations.component.ts